import { CSSProperties } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBUserImage } from '@shared/components/image';
import { Colors, grid } from '@shared/styles';
import { User } from '@shared/types/user';
import { Pill } from './Pill';
import classNames from './PersonPill.module.css';

interface Props {
  user: User;
  maxWidth?: number | 'none';
  noBorder?: boolean;
  showLastName?: boolean;
  pillStyle?: CSSProperties;
  textStyle?: CSSProperties;
}

export function PersonPill({
  user,
  maxWidth = 180,
  noBorder = false,
  showLastName = true,
  pillStyle,
  textStyle,
}: Readonly<Props>) {
  const imageWidth = noBorder ? grid(3) : grid(2);

  return (
    <Pill
      backgroundColor="white"
      round
      key={user.id}
      maxWidth={undefined}
      noBorder={noBorder}
      borderColor={Colors.v2.gray50_25}
      style={pillStyle}
    >
      <View
        className={classNames.row}
        vars={{ 'person-pill-max-width': maxWidth === 'none' ? 'none' : `${maxWidth}px` }}
      >
        <View
          className={classNames.image}
          vars={{
            'person-pill-image-size': noBorder ? 3 : 2,
            'person-pill-image-margin-left': noBorder ? 0 : -0.5,
          }}
        >
          <MBUserImage
            user={user}
            size={noBorder ? 'small' : 'tiny'}
            style={{ width: imageWidth, height: imageWidth }}
          />
        </View>
        <Text size="body1" style={textStyle} numberOfLines={1}>
          {showLastName ? user.fullName : user.firstName}
        </Text>
      </View>
    </Pill>
  );
}
